<template>
    <div>
        <app-bar @save="formHandler" :backBtn="{ visible: true }" :navTab="navTab" :isLoading="isLoading">
            <template v-if="action === 'edit'" #title>Edit Branch</template>
            <template v-else #title>Add Branch</template>

            <template v-if="primaryMerchant" #subtitle>
                <span class="text-caption">
                    Primary Merchant: <b> {{ primaryMerchant }}</b>
                </span>
            </template>
        </app-bar>
        <v-form v-model="validateStatus" ref="formData">
            <Form :action="action" :classification="classification" @assignOldClassification="merchantClassification = $event" />
        </v-form>
    </div>
</template>

<script>
import AppBar from '@/components/Core/AppBar.vue';
import Form from '@/components/Core/Form.vue';

export default {
    name: 'BranchesAction',
    components: {
        AppBar,
        Form
    },
    data() {
        return {
            isLoading: false,
            merchantClassification: '',
            newBranchDetails: {},
            validateStatus: false
        };
    },
    computed: {
        action() {
            return this.$route.params.action;
        },
        classification() {
            if (this.$route.params.action == 'add') {
                return 'BRANCH';
            } else if (this.userInfo.role.id === 'MERCHANT') {
                return 'BRANCH';
            }
            // else if (this.merchantClassification == 'PRIMARY') {
            //     return 'PRIMARY';
            // }

            return '';
        },
        formDetails() {
            return this.$store.getters['merchants/getNewMerchantDetails'];
        },
        merchantDetails() {
            return this.$store.getters['merchants/getMerchantDetails'];
        },
        navTab() {
            if (this.action == 'edit') {
                return false;
            }

            return true;
        },
        primaryMerchant() {
            if (this.formDetails.classification == 'BRANCH') {
                // (Action: Edit) If selected is branch, set default  merchant name by its merchant
                if (this.formDetails.primary_merchant && this.formDetails.primary_merchant.name) {
                    return this.formDetails.primary_merchant.name;
                }
                // (Action: Add)If selected is branch, set default merchant name by its logged in merchant
                else if (this.userInfo.role.id == 'MERCHANT' && this.userInfo.merchant && this.userInfo.merchant.name) {
                    return this.userInfo.merchant.name;
                }
                // (Action: Add) For add branch, set default by previous merchant
                else if (this.merchantDetails && this.merchantDetails.name) {
                    return this.merchantDetails.name;
                }
            }

            return '';
        }
    },
    watch: {
        formDetails(value) {
            this.newBranchDetails = value;
        }
    },
    methods: {
        formHandler() {
            const handler = {
                add: this.saveBranch,
                edit: this.editBranch
            };

            handler[this.action]();
        },
        saveBranch() {
            let merchantDetails = {};
            for (const [key, value] of Object.entries(this.newBranchDetails)) {
                if (value != '') {
                    merchantDetails[key] = value;
                }
            }

            if (merchantDetails.activate_setting === 'scheduled' && !merchantDetails.activate_at) {
                this.$refs.formData.validate();
            } else {
                this.isLoading = true;
                // Prevent override
                merchantDetails['classification'] = 'BRANCH';
                const id = this.$route.params.id ? this.$route.params.id : this.userInfo.merchant.uuid;

                this.$store
                    .dispatch('merchants/addBranch', {
                        id: id,
                        data: merchantDetails
                    })
                    .then((response) => {
                        this.notification({ type: 'success', message: response.message });
                        this.isLoading = false;
                        if (response.data.uuid) {
                            this.$router.push(this.navigation('to', ['view', response.data.uuid]));
                        } else {
                            this.$router.push(this.navigation('cancel'));
                        }
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            }
        },
        editBranch() {
            this.isLoading = true;
            let removeFields = ['created_by', 'created_at', 'id', 'qr_data', 'status', 'updated_at', 'schedule', 'batch_number', 'activate_setting'];
            let merchantDetails = {};
            for (const [key, value] of Object.entries(this.newBranchDetails)) {
                if (removeFields.indexOf(key) === -1) {
                    merchantDetails[key] = value;
                }
            }

            // Prevent override
            // merchantDetails['classification'] = 'BRANCH';
            const id = this.$route.params.branch ? this.$route.params.branch : this.userInfo.merchant.uuid;

            this.$store
                .dispatch('merchants/setMerchant', {
                    id: id,
                    data: merchantDetails
                })
                .then((response) => {
                    this.notification({ type: 'success', message: response.message });
                    this.isLoading = false;
                    if (response.data.classification == 'PRIMARY') {
                        this.$router.push(`/merchants/view/${id}`);
                    } else {
                        this.$router.push(this.navigation('cancel'));
                    }
                })
                .catch(() => {
                    this.isLoading = false;
                });
        }
    }
};
</script>
